import * as React from 'react';

export interface OptionMenuContextValues {
    viewportDepth: number | null;
    setViewportDepth: React.Dispatch<React.SetStateAction<number | null>> | null;
    animating: boolean;
    setAnimating: React.Dispatch<React.SetStateAction<boolean>> | null;
    onMenuOpen: ((depth: number, title: string) => void) | null;
    onMenuBack: (() => void) | null;
}

export const OptionMenuContext = React.createContext<OptionMenuContextValues>({
    viewportDepth: null,
    setViewportDepth: null,
    animating: false,
    setAnimating: null,
    onMenuOpen: null,
    onMenuBack: null,
});
